<template>
  <div>
    <client-only>
      <VueRecaptcha
        @success="$emit('success', $event)"
        @expired="$emit('expired')"
        @error="$emit('error')"
      />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { Checkbox as VueRecaptcha, useRecaptchaProvider } from 'vue-recaptcha';

defineEmits<{
  (e: 'success', token: string): void;
  (e: 'expired' | 'error'): void;
}>();

if (import.meta.client) useRecaptchaProvider();
</script>
